import { request } from '@umijs/max';

export async function getCaptcha(req: API.LoginCaptchaReq) {
  return request('/api/auth/captcha', {
    method: 'POST',
    data: req
  });
}

export async function login(req: API.LoginReq) {
  return request<API.LoginRes>('/api/auth/login', {
    method: 'POST',
    data: req
  });
}

export async function logout() {
  return request('/api/auth/logout', {
    method: 'POST'
  });
}